<template>
  <div class="wrapped-markdown" v-bind="$attrs" v-html="compiledMarkdown"></div>
</template>

<script>
import {marked} from "marked";

export default {
  name: "MarkedWrapper",
  props: {
    content: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    compiledMarkdown() {
      // Convert the markdown content to HTML
      marked.use({
        renderer: {
          link: (token) => {
            return `<a href="${token.href}" target="_blank">${token.text}</a>`;
          },
          code: (token) => {
            return `<div>${token.text}</div>`;
          }
        }
      });
      return marked.parse(this.content || '', this.options);
    }
  }
};
</script>

<style lang="scss">
.wrapped-markdown {
  h1, h2, h3, h4, h5, h6 {
    color: rgba(0, 0, 0, 0.87);
    margin: 1.5rem 0 0.5rem 0;
  }

  h1 {
    font-size: 2rem;
    font-weight: 700;
    line-height: 2.225rem;
    letter-spacing: normal;
    font-family: "helvetica-neue-lt-pro-cond", sans-serif;
    text-transform: uppercase;
  }

  h2 {
    font-size: 2rem;
    font-weight: 700;
    line-height: 2.225rem;
    letter-spacing: normal;
    font-family: "helvetica-neue-lt-pro-cond", sans-serif;
    text-transform: uppercase;
  }

  h3 {
    font-size: 2rem;
    font-weight: 700;
    line-height: 2.225rem;
    letter-spacing: normal;
    font-family: "helvetica-neue-lt-pro-cond", sans-serif;
    text-transform: uppercase;
  }

  h4 {
    font-size: 1.625rem;
    font-weight: 600;
    line-height: 1.8rem;
    letter-spacing: normal;
    font-family: "garamond-premier-pro", serif;
    text-transform: none;
  }

  h5 {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.75rem;
    letter-spacing: normal;
    font-family: "helvetica-neue-lt-pro-cond", serif;
    text-transform: uppercase;
  }

  h6 {
    font-size: 1.15rem;
    font-weight: 700;
    line-height: 2.35rem;
    letter-spacing: normal;
    font-family: "garamond-premier-pro", serif;
    text-transform: none;
  }

  hr {
    border-top: 1px solid rgba(255, 255, 255, 0.32);
    border-bottom: 0;
    margin: 1rem 0;
  }

  p, li {
    font-size: 16px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.77);
    margin: 0.5rem 0;
    font-family: "helvetica-neue-lt-pro", sans-serif;
  }
}

@media screen and (max-width: 768px) {
  .wrapped-markdown {
    h1, h2, h3 {
      font-size: 1.15rem;
      line-height: 1.35rem;
    }
    h4 {
      font-size: 1.15rem;
      line-height: 1.35rem;
    }
    h5 {
      font-size: 0.875rem;
      line-height: 1rem;
    }
    h6 {
      font-size: 0.75rem;
      line-height: 1rem;
    }

    p, li {
      font-size: 14px;
    }
  }
}

</style>
